import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ErrorBoundary from '@fs/zion-error-boundary'
import { boolAttr } from '@fs/zion-frontend-friends'
import { css } from '@linaria/core'
import { ResponsiveProvider } from '../responsive'
import LayoutBand from '../layout-band'
import { GridStart } from '../grid'
import { colors } from '../theme'

const appCss = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
  [root-full-screen] & {
    overflow-x: hidden;
    overflow-y: auto;
  }
  &[no-scroll] {
    /* TODO: make this actually work with HF */
    flex-shrink: 1;
  }
`

const fullScreenCss = css`
  [root-full-screen] & {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  }
`

const FullWidthBand = ({ children }) => (
  <ResponsiveProvider className={fullScreenCss}>
    <GridStart className={fullScreenCss}>{children}</GridStart>
  </ResponsiveProvider>
)

function AppLayout({ fullWidth = false, noScroll = false, backgroundColor = colors.gray00, children }) {
  const Wrapper = fullWidth ? FullWidthBand : LayoutBand

  useEffect(() => {
    document.body.style.backgroundColor = backgroundColor
  }, [backgroundColor])

  return (
    <ErrorBoundary>
      <div no-scroll={boolAttr(noScroll)} style={{ backgroundColor }} className={appCss}>
        <Wrapper>{children}</Wrapper>
      </div>
    </ErrorBoundary>
  )
}

export default AppLayout

AppLayout.propTypes = {
  /** Children are required */
  children: PropTypes.node.isRequired,

  /** Does your app need to stretch to the edges of the screen? Or do you need to control your own LayoutBands? Set this to true */
  fullWidth: PropTypes.bool,

  /** Set this to true if you want to prevent vertical scrolling on the page. (Meant for use with ZoomPan layouts) */
  noScroll: PropTypes.bool,

  /** Provides a background color to the content section of the page. */
  backgroundColor: PropTypes.string,
}
